import { authenticationService } from "@/services/AuthenticationService";
import { getPermissions } from "@/helper/collection";

export const FnbRoutes = {
  path: "/fnb",
  name: "FNB",
  redirect: "/fnb/raw-materials",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/FoodAndBeveragesContainer/FnbHome.vue"),
      meta: {},
    },
    {
      path: "raw-materials-categories",
      name: "Raw Material Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/rawMaterialsCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              ),
      },
    },
    {
      path: "add-raw-material-categories",
      name: "Add Raw Material Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/addRawMaterialCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                2
              ),
      },
    },
    {
      path: "edit-raw-material-categories",
      name: "Edit Raw Material Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/editRawMaterialCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                2
              ),
      },
    },
    {
      path: "view-raw-material-categories",
      name: "View Raw Material Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialCategoriesComponents/viewRawMaterialCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              ),
      },
    },
    {
      path: "raw-materials",
      name: "Raw Materials",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/rawMaterials"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                1
              ),
      },
    },
    {
      path: "add-raw-material",
      name: "Add Raw Material",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/addRawMaterial"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                2
              ),
      },
    },
    {
      path: "edit-raw-material",
      name: "Edit Raw Material",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/editRawMaterial"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                2
              ),
      },
    },
    {
      path: "view-raw-material",
      name: "View Raw Material",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/viewRawMaterial"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                79,
                1
              ),
      },
    },
    {
      path: "modifier-categories",
      name: "Modifier Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/Modifiers/ListModifier"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              ),
      },
    },
    {
      path: "add-modifier-categories",
      name: "Add Modifier Category",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/Modifiers/AddModifier"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                78,
                1
              ),
      },
    },
    {
      path: "vendors",
      name: "Vendors",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsComponents/vendors"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              ),
      },
    },
    {
      path: "add-vendor",
      name: "Add Vendor",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsComponents/addVendor"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              ),
      },
    },
    {
      path: "edit-vendor",
      name: "Edit Vendor",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsComponents/editVendor"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              ),
      },
    },
    {
      path: "view-vendor",
      name: "View Vendor",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsComponents/viewVendor"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              ),
      },
    },
    {
      path: "vendor-mapping",
      name: "Vendor Mapping",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/vendorMapping"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              ),
      },
    },
    {
      path: "add-vendor-mapping",
      name: "Add Vendor Mapping",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/addVendorMapping"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              ),
      },
    },
    {
      path: "edit-vendor-mapping",
      name: "Edit Vendor Mapping",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/editVendorMapping"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                2
              ),
      },
    },
    {
      path: "view-vendor-mapping",
      name: "View Vendor Mapping",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/VendorsMappingComponents/viewVendorMapping"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                80,
                1
              ),
      },
    },
    {
      path: "purchase-order",
      name: "Purchase Orders",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/purchaseOrder"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                1
              ),
      },
    },
    {
      path: "add-purchase-order",
      name: "Add Purchase Order",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/addPurchaseOrderv2"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                1
              ),
      },
    },
    {
      path: "view-purchase-order",
      name: "View Purchase Order",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/viewPurchaseOrder"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                1
              ),
      },
    },
    {
      path: "edit-purchase-order",
      name: "Edit Purchase Order",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/editPurchaseOrder"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                81,
                2
              ),
      },
    },
    {
      path: "food-categories",
      name: "Food Categories",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/foodCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                1
              ),
      },
    },
    {
      path: "add-food-categories",
      name: "Add Food Categories",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/addFoodCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                2
              ),
      },
    },
    {
      path: "edit-food-categories",
      name: "Edit Food Categories",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/editFoodCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                2
              ),
      },
    },
    {
      path: "view-food-categories",
      name: "View Food Categories",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FoodCategoriesComponents/viewFoodCategories"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                88,
                1
              ),
      },
    },
    {
      path: "recipes",
      name: "Recipes",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/recipes"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                1
              ),
      },
    },
    {
      path: "add-recipe",
      name: "Add Recipe",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/addRecipe"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                2
              ),
      },
    },
    {
      path: "view-recipe",
      name: "View Recipe",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/viewRecipe"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                1
              ),
      },
    },
    {
      path: "edit-recipe",
      name: "Edit Recipe",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/editRecipe"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                89,
                2
              ),
      },
    },
    {
      path: "subrecipes",
      name: "Sub Recipes",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/subrecipes"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                1
              ),
      },
    },
    {
      path: "add-subrecipe",
      name: "Add Sub Recipe",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/addSubRecipe"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                2
              ),
      },
    },
    {
      path: "edit-subrecipe",
      name: "Edit Sub Recipe",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/RecipesComponents/editSubRecipe"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                238,
                2
              ),
      },
    },
    //Customization
    {
      path: "customization",
      name: "Customization",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/customizationComponents/customizationV2"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                ""
              ),
      },
    },
    {
      path: "add-customization",
      name: "Add Customization",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/customizationComponents/addCustomizationV2"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                2
              ),
      },
    },
    {
      path: "edit-customization",
      name: "Edit Customization",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/customizationComponents/editCustomizationV2"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                2
              ),
      },
    },
    {
      path: "view-customization",
      name: "View Customization",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/customizationComponents/viewCustomization"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                164,
                1
              ),
      },
    },
    //customization ends
    //vip fnb

    {
      path: "vip-fnb",
      name: "Vip Fnb",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/vipfnb"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                245,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                245,
                1
              ),
      },
    },

    {
      path: "add-edit-vip-fnb",
      name: "Add | Edit Vip Fnb",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/addvipfnb"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              ),
      },
    },

    {
      path: "fnb-items",
      name: "FnB Items",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/fnbItems"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              ),
      },
    },
    {
      path: "add-fnb-item",
      name: "Add Fnb Item",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/addFnbItem"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                2
              ),
      },
    },
    {
      path: "view-fnb-item",
      name: "View Fnb Item",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/viewFnbItem"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                1
              ),
      },
    },
    {
      path: "edit-fnb-item",
      name: "Edit Fnb Item",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBComponents/editFnbItem"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                90,
                2
              ),
      },
    },
    {
      path: "itemcostprice",
      name: "Item Cost Price",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/ItemCostPrice"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                1
              ),
      },
    },
    {
      path: "add-itemcostprice",
      name: "Add Item Cost Price",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/addItemCostPrice"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                2
              ),
      },
    },
    {
      path: "edit-itemcostprice",
      name: "Edit Item Cost Price",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/editItemCostPrice"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                2
              ),
      },
    },
    {
      path: "view-itemcostprice",
      name: "View Item Cost Price",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/viewItemCostPrice"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                131,
                1
              ),
      },
    },
    {
      path: "store-management",
      name: "Store Management",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StoreManagementComponents/storeManagement"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                82,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                82,
                1
              ),
      },
    },
    {
      path: "add-store-management",
      name: "Add Store Management",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StoreManagementComponents/addStoreManagement"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                82,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                ""
              ),
      },
    },
    {
      path: "edit-store-management",
      name: "Edit Store Management",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StoreManagementComponents/editStoreManagement"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                82,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                82,
                2
              ),
      },
    },
    {
      path: "stock-take",
      name: "Stock Take",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/stock"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                86,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                86,
                1
              ),
      },
    },
    {
      path: "stock-take-logs",
      name: "Stock Take Logs",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/stockTakeLogs"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                161,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                161,
                1
              ),
      },
    },
    {
      path: "stock-take-summary",
      name: "Stock Take Summary",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/stockTakeLogSummary"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                161,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                161,
                1
              ),
      },
    },
    //stocktakereason
    {
      path: "stock-take-reasons",
      name: "Stock Variance Reasons",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/stocktakereasons"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          312,
          1
        ),
      },
    },
    {
      path: "edit-stocktakereasons",
      name: "Edit Stock Take Reasons",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/editstocktakereasons"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          312,
          2
        ),
      },
    },
    {
      path: "stock-in",
      name: "Store",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/stockIn"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                1
              ),
      },
    },
    {
      path: "edit-stock-in",
      name: "Update Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/updateStockIn"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                2
              ),
      },
    },
    {
      path: "bulk-edit-stock-in",
      name: "Update Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/bulkUpdateStockIn"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                2
              ),
      },
    },
    {
      path: "add_property_in_out",
      name: "Add Proprty In/Out",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/addPropertyInOut"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                2
              ),
      },
    },
    {
      path: "property-in-out",
      name: "property_in_out",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/listPropertyInOut"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                1
              ),
      },
    },
    {
      path: "property-in-out-logs",
      name: "propertyInOutLogs",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/propertyInOutAuditLogs"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                303,
                1
              ),
      },
    },
    {
      path: "good-return",
      name: "Good Return",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/GoodReturn/goodReturn.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                1
              ),
        // getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 33, 1)
      },
    },
    {
      path: "add-good-return",
      name: "Add Good Return",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/GoodReturn/addGoodReturn.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                2
              ),
        // getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 33, 2)
      },
    },
    {
      path: "view-grn",
      name: "View GRN",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/StockComponents/viewGrn"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                83,
                1
              ),
      },
    },
    {
      path: "transfer-stocks",
      name: "Transfer Stocks",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocks"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                84,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                2
              ),
      },
    },
    {
      path: "transfer-stocks-v2",
      name: "Category Wise Transfer Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocksV2"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                84,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                33,
                2
              ),
      },
    },
    {
      path: "transfer-stocks-logs",
      name: "Transfer Stocks Logs",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/TransferStocks/transferStocksLogs"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                85,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                85,
                2
              ),
      },
    },
    // {
    //     path: 'fnb-pricing',
    //     name: 'FnB Pricing',
    //     component: () => import('@/components/Pages/FoodAndBeveragesContainer/FnbPricingComponents/fnbpricing'),
    //     meta: {
    //         permissions: authenticationService.get("ENABLE_FNB") == 'Y' ? getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 152, 1) : getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // //addFnbPricing.vue
    // {
    //     path: 'add-fnb-pricing',
    //     name: 'Add FnB Pricing',
    //     component: () => import('@/components/Pages/FoodAndBeveragesContainer/FnbPricingComponents/addFnbPricing'),
    //     meta: {
    //         permissions: authenticationService.get("ENABLE_FNB") == 'Y' ? getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 152, 2) : getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: 'edit-fnb-pricing',
    //     name: 'Edit FnB Pricing',
    //     component: () => import('@/components/Pages/FoodAndBeveragesContainer/FnbPricingComponents/editFnbPricing'),
    //     meta: {
    //         permissions: authenticationService.get("ENABLE_FNB") == 'Y' ? getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 152, 2) : getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: 'view-fnb-pricing',
    //     name: 'View FnB Pricing',
    //     component: () => import('@/components/Pages/FoodAndBeveragesContainer/FnbPricingComponents/viewFnbPricing'),
    //     meta: {
    //         permissions: authenticationService.get("ENABLE_FNB") == 'Y' ? getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '', 152, 1) : getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    {
      path: "fnb-wastage",
      name: "Fnb Wastage",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/fnbWastage.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                1
              ),
      },
    },
    {
      path: "add-fnb-wastage",
      name: "Add Fnb Wastage",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/addFnbWastage.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                2
              ),
      },
    },
    {
      path: "edit-fnb-wastage",
      name: "Edit Fnb Wastage",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/editFnbWastage.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                2
              ),
      },
    },
    {
      path: "view-fnb-wastage",
      name: "View Fnb Wastage",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/viewFnbWastage.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                91,
                1
              ),
      },
    },
    {
      path: "concession-stock",
      name: "Concession Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/concessionStock.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                1
              ),
      },
    },
    {
      path: "add-concession-stock",
      name: "Add Concession Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/addConcessionStock.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                2
              ),
      },
    },
    {
      path: "edit-concession-stock",
      name: "Edit Concession Stock",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/ConcessionStockComponents/editConcessionStock.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                87,
                2
              ),
      },
    },
    {
      path: "invoice",
      name: "Invoice",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/listInvoice.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                1
              ),
      },
    },
    {
      path: "add-invoice",
      name: "Add Invoice",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/addInvoice.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                2
              ),
      },
    },
    {
      path: "edit-invoice",
      name: "Edit Invoice",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/editInvoice.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                2
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                2
              ),
      },
    },
    {
      path: "view-invoice",
      name: "View Invoice",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/viewInvoice.vue"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                92,
                1
              ),
      },
    },

    {
      path: "view-fnb-transaction/:ft_id",
      name: "View F&B Transaction",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbtransactionComponents/viewFnBTransaction"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                162,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                162,
                1
              ),
      },
    },
    {
      path: "view-fnb-app-transaction/:ft_id",
      name: "View F&B App Transaction",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/viewFnBAppTransaction"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              ),
      },
    },
    {
      path: "fnb-stations",
      name: "Fnb Stations",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbStations/fnbStationsList"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              ),
      },
    },
    {
      path: "edit-fnb-stations",
      name: "EditFnbStations",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbStations/editFnbStations"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              ),
      },
    },
    {
      path: "add-fnb-stations",
      name: "AddFnbStations",
      component: () =>
        import(
          "@/components/Pages/FoodAndBeveragesContainer/FnbStations/addFnbStations"
        ),
      meta: {
        permissions:
          authenticationService.get("ENABLE_FNB") == "Y"
            ? getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              )
            : getPermissions(
                ["SuperAdmin", "CinemaManager", "HoManager"],
                false,
                "",
                163,
                1
              ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/fnbRoutes.js